/* Local helpers reused across CaseDetail tabs.
   Kept here (rather than /lib/formatters) because the legacy CaseDetailPage
   exposed these names directly; keeping the same signatures avoids touching
   the rest of the codebase. */

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    const [y, m, d] = iso.substring(0, 10).split("-");
    return `${d}/${m}/${y}`;
  } catch { return iso; }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return `${d.toLocaleDateString("pt-BR")} ${d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })}`;
  } catch { return iso; }
}

export function pendingDiscrepancyCount(analyses) {
  return (analyses || []).reduce(
    (s, a) => s + (a.discrepancies || []).filter((d) => !d.resolved_at).length,
    0
  );
}
